"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactI18next = require("react-i18next");
var _clsx = _interopRequireDefault(require("clsx"));
var _Core = require("@Core");
var _core = require("@material-ui/core");
var _sociallinks = _interopRequireDefault(require("../sociallinks"));
var _svgicon = _interopRequireDefault(require("../../helper/svgicon"));
var _checkIsTouch = _interopRequireDefault(require("../../utils/checkIsTouch"));
var _useOnScreen = _interopRequireDefault(require("../../hooks/useOnScreen"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const useStyles = (0, _core.makeStyles)(theme => {
  var _theme$palette$backgr, _theme$palette$foregr, _theme$palette$foregr2, _theme$palette$foregr3;
  return {
    footer: {
      background: (_theme$palette$backgr = theme.palette.background) === null || _theme$palette$backgr === void 0 || (_theme$palette$backgr = _theme$palette$backgr.footer) === null || _theme$palette$backgr === void 0 ? void 0 : _theme$palette$backgr.bar,
      bottom: 0,
      left: 0,
      position: "fixed",
      right: 0,
      zIndex: theme.zIndex.footer
    },
    footerHasFabButton: {
      paddingRight: theme.spacing(8),
      [theme.breakpoints.up("md")]: {
        paddingRight: 0
      }
    },
    navigation: {
      background: "transparent",
      height: "calc(env(safe-area-inset-bottom) + 75px)",
      paddingBottom: "env(safe-area-inset-bottom)"
    },
    list: {
      color: (_theme$palette$foregr = theme.palette.foreground) === null || _theme$palette$foregr === void 0 ? void 0 : _theme$palette$foregr.footer.navigation,
      "& :hover": {
        color: (_theme$palette$foregr2 = theme.palette.foreground) === null || _theme$palette$foregr2 === void 0 ? void 0 : _theme$palette$foregr2.footer.navigationHover
      },
      [theme.breakpoints.down("sm")]: {
        "& .MuiBottomNavigationAction-label": {
          marginTop: theme.spacing(1)
        }
      },
      [theme.breakpoints.up("md")]: {
        "& .MuiBottomNavigationAction-wrapper": {
          flexDirection: "row"
        },
        "& .MuiBottomNavigationAction-label": {
          lineHeight: 1,
          marginLeft: theme.spacing(2)
        }
      }
    },
    listSelected: {
      color: (_theme$palette$foregr3 = theme.palette.foreground) === null || _theme$palette$foregr3 === void 0 ? void 0 : _theme$palette$foregr3.footer.navigationSelected
    },
    socialMedia: {
      background: theme.palette.background.drawer,
      bottom: "calc(env(safe-area-inset-bottom) + 75px)",
      left: 0,
      position: "absolute",
      width: "100%",
      zIndex: theme.zIndex.socialMedia
    },
    socialMediaWrapper: {
      alignItems: "center",
      background: theme.palette.background.drawer,
      display: "flex",
      justifyContent: "space-between",
      paddingBottom: theme.spacing(3.5),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingTop: theme.spacing(3.5),
      [theme.breakpoints.up("md")]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3)
      }
    },
    columns: {
      alignItems: "center"
    },
    leftColumn: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex"
      }
    },
    middleColumn: {
      display: "flex",
      justifyContent: "center",
      [theme.breakpoints.up("sm")]: {
        justifyContent: "flex-start"
      },
      [theme.breakpoints.up("md")]: {
        justifyContent: "center"
      }
    },
    rightColumn: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      marginTop: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        justifyContent: "flex-end",
        marginTop: 0
      }
    }
  };
});
const Footer = _ref => {
  var _menuGroup$items, _customLinks$find$url, _customLinks$find;
  let {
    menuGroup,
    socialMedia,
    onScreen
  } = _ref;
  const [appData] = (0, _react.useContext)(_Core.AppContext);
  const {
    customLinks = []
  } = appData || {};
  const [data, setData] = (0, _react.useState)();
  const {
    REACT_APP_FAB_BUTTON_IN_FOOTER
  } = process.env;
  const {
    i18n,
    t
  } = (0, _reactI18next.useTranslation)();
  const ref = (0, _react.useRef)();
  const isVisible = (0, _useOnScreen.default)(ref);
  const css = useStyles();
  (0, _react.useEffect)(() => {
    async function fetchData() {
      const {
        REACT_APP_PATH,
        REACT_APP_PROVIDER_ID
      } = process.env;
      const fetchURL = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/Details.api?id=").concat(REACT_APP_PROVIDER_ID, "&lang=").concat(i18n.language);
      const response = await fetch(fetchURL);
      setData(await response.json());
    }
    fetchData();
  }, [i18n.language]);
  const urls = data === null || data === void 0 ? void 0 : data.urls;
  let bookingURL = null;
  let requestURL = null;
  if (urls && urls.length > 0) {
    urls.filter(url => {
      if ((url === null || url === void 0 ? void 0 : url.type) === "booking") {
        return bookingURL = url === null || url === void 0 ? void 0 : url.url;
      }
      if ((url === null || url === void 0 ? void 0 : url.type) === "request") {
        return requestURL = url === null || url === void 0 ? void 0 : url.url;
      }
      return null;
    });
  }
  if (!(menuGroup !== null && menuGroup !== void 0 && (_menuGroup$items = menuGroup.items) !== null && _menuGroup$items !== void 0 && _menuGroup$items.length) > 0) {
    return null;
  }
  if (!REACT_APP_FAB_BUTTON_IN_FOOTER) {
    onScreen(isVisible);
  }
  const isTouch = (0, _checkIsTouch.default)();
  const touchURL = (_customLinks$find$url = customLinks === null || customLinks === void 0 || (_customLinks$find = customLinks.find(_ref2 => {
    let {
      identifier
    } = _ref2;
    return identifier === "touch";
  })) === null || _customLinks$find === void 0 ? void 0 : _customLinks$find.url) !== null && _customLinks$find$url !== void 0 ? _customLinks$find$url : "/";
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, socialMedia && /*#__PURE__*/_react.default.createElement("div", {
    className: css.socialMedia,
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_core.Container, {
    className: css.socialMediaWrapper
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.columns,
    container: true
  }, !isTouch && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.leftColumn,
    item: true,
    md: 4
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle1"
  }, t("site.ui.labels.connectNow"))), isTouch ? /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: touchURL
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    color: "primary",
    fullWidth: true,
    variant: "outlined"
  }, t("site.ui.buttons.home"))))) : /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.middleColumn,
    item: true,
    xs: 12,
    sm: 6,
    md: 4
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, requestURL && /*#__PURE__*/_react.default.createElement(_core.Button, {
    color: "primary",
    fullWidth: true,
    variant: "outlined",
    href: requestURL,
    target: "_blank"
  }, t("site.ui.buttons.enquiry"))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, bookingURL && /*#__PURE__*/_react.default.createElement(_core.Button, {
    color: "primary",
    fullWidth: true,
    variant: "contained",
    href: bookingURL,
    target: "_blank"
  }, t("site.ui.buttons.booking"))))), !isTouch && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    className: css.rightColumn,
    item: true,
    xs: 12,
    sm: 6,
    md: 4
  }, /*#__PURE__*/_react.default.createElement(_sociallinks.default, null))))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: (0, _clsx.default)(css.footer, {
      [css.footerHasFabButton]: !isTouch && REACT_APP_FAB_BUTTON_IN_FOOTER
    })
  }, /*#__PURE__*/_react.default.createElement(_core.BottomNavigation, {
    showLabels: true,
    className: css.navigation
  }, menuGroup.items.map(item => {
    return /*#__PURE__*/_react.default.createElement(DetectLink, _extends({
      key: item === null || item === void 0 ? void 0 : item.id
    }, item));
  }))));
};
const DetectLink = item => {
  const {
    REACT_APP_PATH
  } = process.env;
  const {
    id,
    title,
    link,
    selected,
    icon
  } = item;
  const css = useStyles();
  const svgIcon = icon !== null && icon !== void 0 && icon.filename ? /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    wrapper: "span",
    src: REACT_APP_PATH + icon.filename,
    size: 24
  }) : "";

  // check if external

  if (link.indexOf("http://") >= 0 || link.indexOf("https://") >= 0) {
    return /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
      key: id,
      className: (0, _clsx.default)({
        [css.list]: true,
        [css.listSelected]: selected
      }),
      showLabel: true,
      label: /*#__PURE__*/_react.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: title
        }
      }),
      icon: svgIcon,
      onClick: () => window.open(link, "_blank")
    });
  } else {
    return /*#__PURE__*/_react.default.createElement(_core.BottomNavigationAction, {
      key: id,
      className: (0, _clsx.default)({
        [css.list]: true,
        [css.listSelected]: selected
      }),
      showLabel: true,
      label: /*#__PURE__*/_react.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: title
        }
      }),
      icon: svgIcon,
      component: _reactRouterDom.Link,
      to: link
    });
  }
};
var _default = exports.default = Footer;